import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { _HttpClient } from '@delon/theme';
import { map, catchError } from 'rxjs/operators';
import { URLS } from '../constant/interface';
import { ACLService } from '@delon/acl';
/**
 * 公告管理服务
 */
@Injectable({
  providedIn: 'root',
})
export class NoticeService {
  public subject: Subject<any> = new Subject<any>();

  public get currentNotice(): Observable<any> {
    return this.subject.asObservable();
  }

  constructor(private http: _HttpClient, private aclService: ACLService) {}

  public updateNotice() {
    // 权限判断
    if (this.aclService.canAbility('system.notice.list')) {
      this.getNoticeList().subscribe(v => {
        this.subject.next(v);
      });
    }
  }

  /**
   * >>>>>>>>>>>>>> http相关
   */
  // 获取公告
  public getNoticeList(params = { pi: 1, ps: 5 }): Observable<any> {
    return this.http.post(URLS.systemNoticeList.url, params).pipe(
      map(v => (v.status === 0 ? v.list : v.errorMsg)),
      catchError(err => of(err)),
    );
  }
}
